module.exports = __webpack_public_path__ + "static/media/roof-4.8d03965d.jpg";